<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card ">
                    <div class="card-header border-bottom d-print-none">
                        <div class="d-md-flex align-items-center m-t-20">
                            <div class="d-flex align-items-center">
                                <div>
                                    <h4 class="card-title" v-if="did">{{did.short_name}}</h4>
                                    <h5 class="card-subtitle"> Please keep your profile information always current in
                                        order
                                        to help you when you contact us. </h5>
                                </div>
                            </div>
                            <div class="ml-auto">
                                <a href="javascript:window.print()" class="btn btn-outline-secondary btn-outline m-l-5"
                                        id="print" type="button">
                                    <span>
                                        <i class="fa fa-print"></i> Print
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-blue p-30">
                        <div class="row">
                            <div class="col-lg-5 col-md-6">
                                <div class="card card-shadow rounded member-card-border" id="printMe">
                                    <div class="card-body">
                                        <div class="carousel slide" data-ride="carousel" id="myCarousel">
                                            <!-- Carousel items -->
                                            <div class="carousel-inner">
                                                <div class="carousel-item flex-column active">
                                                    <div class="d-flex no-block al m-r-15 align-items-center">
                                                        <blockie :address="memberid" class="cc display-6 m-r-15"
                                                                 style="width: 40px"></blockie>
                                                        <div class="m-t-10">
                                                            <h4>{{did.short_name}}</h4>
                                                            <h5>{{did_record.name}}</h5>
                                                            <h6 class="font-medium">{{did_record.address}}</h6>
                                                        </div>
                                                        <div class="ml-auto m-t-15">
                                                            <img :src="qrUrl" alt="" height="100px"
                                                                 style="float: right; margin-right: -5px; margin-top: -5px;"
                                                                 v-if="qrUrl">
                                                        </div>
                                                    </div>
                                                    <div class="row text-center  m-t-30">
                                                        <div @click="toExplorer()"
                                                             class="col-12 font-weight-bold  text-left d-flex justify-content-between">
                                                            <span class="font-20">{{formatted_did}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <div class="col-8 font-16 " v-if="did">
<!--                                                            {{currentOrg.name.indexOf('Ltd.') !== -1 ? currentOrg.name.substring(0, currentOrg.name.indexOf('Ltd.')) : currentOrg.name}}-->
                                                            Blockchain traceability
                                                        </div>
                                                        <div class="col-4 bws-ico d-flex ">
                                                            <span class="ml-4 mr-1"> Powered by</span>
                                                            <img alt="" height="18px"
                                                                 src="@/assets/images/orange_bws_logo.png" width="18px">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QRCode from "qrcode";
    import {mapGetters} from "vuex";
    import Blockie from "../../../common/Blockie";

    export default {
        name: "MemberCard",
        components: {Blockie},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        props: ['catalogid', 'memberid'],
        data() {
            return {
                qrUrl: null,
                did: null,
                formatted_did: null,
                did_record: {
                    name: null,
                    address: null
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                try {
                    $(".preloader").fadeIn();
                    await Promise.all([
                        this.generateQr(),
                        this.getDid(),
                        this.getDidRecords()
                    ])
                } catch (e) {

                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getDid() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs/${this.catalogid}/dids/${this.memberid}`);
                    this.did = data;
                    let did_str = data.did.substring(2, data.did.length);
                    this.formatted_did = 'did:bws:' + did_str.substring(0, 13) + '....' + did_str.substring(did_str.length - 13);
                } catch (e) {
                }
            },
            async getDidRecords() {
                try {
                    let {data} = await this.$identity.get(`/identity/dids/${this.memberid}/properties?page=0&per_page=1000`);
                    let found_name = data.property_list.find(p => p.name.toLowerCase().indexOf('name') !== -1);
                    let found_address = data.property_list.find(p => p.name.toLowerCase().indexOf('address') !== -1);
                    this.did_record.name = found_name ? found_name.fact.value : null;
                    this.did_record.address = found_address ? found_address.fact.value : null;
                } catch (e) {
                }
            },
            async generateQr() {
                let qr = 'https://www.maya.explorer.borlaug.network/identity/did:bws:' + this.memberid.substring(2, this.memberid.length);

                this.qrUrl = await QRCode.toDataURL(qr, {
                    width: 200,
                    type: 'svg',
                    color: {
                        dark: '#3e5569',  // Blue dots
                        light: '#0000' // Transparent background
                    }
                });
            },
            printCard() {
                this.$htmlToPaper('printMe');
            },
            toExplorer() {
                window.open("someurl", "_blank");
            }
        }
    }
</script>

<style scoped>
    .member-card-border {
        border: 1px solid #a9a9a9;
    }
</style>
